export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/03e8d50d453f857966e4327a22f70e85.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-0 pt-20">
        {/* Left Text */}
        <div className="flex-1 text-center lg:text-left">
          <p className="text-[#00d4aa] text-xs font-semibold tracking-[4px] uppercase mb-6">
            Application Development
          </p>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6">
            Modern
            <br />
            <span className="text-[#00d4aa]">Applications</span>
          </h1>
          <p className="text-white/70 text-lg md:text-xl leading-relaxed max-w-xl mx-auto lg:mx-0">
            AKIAN DOO is a team of experts developing modern applications.
            Our products are designed to enhance user experience and improve the security of mobile devices.
          </p>

          {/* Stats */}
          <div className="mt-12 flex flex-wrap gap-8 justify-center lg:justify-start">
            <div>
              <p className="text-3xl font-black text-white">100%</p>
              <p className="text-white/50 text-sm mt-1 tracking-wide">Privacy Focused</p>
            </div>
            <div className="w-px bg-white/20 hidden sm:block" />
            <div>
              <p className="text-3xl font-black text-white">24/7</p>
              <p className="text-white/50 text-sm mt-1 tracking-wide">Security</p>
            </div>
            <div className="w-px bg-white/20 hidden sm:block" />
            <div>
              <p className="text-3xl font-black text-white">Expert</p>
              <p className="text-white/50 text-sm mt-1 tracking-wide">Team</p>
            </div>
          </div>
        </div>

        {/* Right Visual */}
        <div className="flex-1 flex justify-center lg:justify-end">
          <div className="relative w-64 md:w-80">
            {/* Phone mockup */}
            <div className="relative mx-auto w-56 md:w-64 bg-gradient-to-b from-gray-800 to-gray-900 rounded-[3rem] p-3 shadow-2xl border border-white/10">
              <div className="bg-black rounded-[2.5rem] overflow-hidden aspect-[9/19]">
                <img
                  src="https://readdy.ai/api/search-image?query=iOS%20mobile%20app%20interface%20with%20teal%20and%20dark%20theme%2C%20VPN%20security%20app%20dashboard%2C%20clean%20minimal%20UI%20design%2C%20glowing%20shield%20icon%2C%20modern%20typography%2C%20dark%20background%20with%20accent%20colors&width=400&height=800&seq=phone001&orientation=portrait"
                  alt="iOS App Interface"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Notch */}
              <div className="absolute top-3 left-1/2 -translate-x-1/2 w-20 h-5 bg-black rounded-full" />
            </div>
            {/* Glow */}
            <div className="absolute inset-0 bg-[#00d4aa]/20 rounded-full blur-3xl -z-10 scale-75" />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
